import axiosIns from '@/api/axios';


export const GET_TRAINING_PROVIDER = (args) => {
    return axiosIns.get('/master-data/training-provider', { params: args });
}
export const GET_TRAINING_BY_PROVIDER = (providerId, args) => {
    return axiosIns.get(`/master-data/training/${providerId}`, { params: args });
};

export const GET_PROVIDER_BY_COMPETENCY = (args) => {
    return axiosIns.get(`/master-data/provider?competency=${args}`);
};

